import { Button } from "../../Atoms/Button";
import { Input } from "../../Atoms/Inputs/Input";
import * as S from "./styles";
import { useAdminDeliveryDetail } from "./useAdminDeliveryDetail";

export const AdminDeliveryDetailTemplate = () => {
  const {
    Controller,
    control,
    handleSubmit,
    register,
    submitForm,
    contaIugu,
    errors,
  } = useAdminDeliveryDetail();

  return (
    <S.Container>
      <h1>Dados Delivery</h1>

      <S.Form onSubmit={handleSubmit(submitForm)}>
        <div>
          <h3>Informações Básicas</h3>
        </div>

        <div>
          <Input label="Uf" disabled {...register("uf")} />
        </div>

        <div>
          <Input label="Cidade" disabled {...register("cidade")} />
        </div>

        <div>
          <h3>Informações Financeiras</h3>
        </div>

        <S.WrapperDataIugu>
          <div>
            <Input value={contaIugu?.nome} disabled label="Nome" />
          </div>

          <div>
            <Input value={contaIugu?.cnpj} disabled label="CNPJ" />
          </div>

          <div>
            <Input value={contaIugu?.idConta} disabled label="Conta Iugu" />
          </div>
        </S.WrapperDataIugu>

        <div>
          <h3>Informações de Atendimento</h3>
        </div>

        <div>
          <Input
            required
            {...register("tempoMedio")}
            label="Tempo Médio"
            variant={"edit"}
            placeholder="hh:mm"
          />
        </div>

        <div>
          <Input
            required
            variant={"edit"}
            label="Margem de Agendamento"
            placeholder="00:00"
            {...register("margemAtendimento")}
          />
        </div>

        <div>
          <Controller
            control={control}
            name="quantidadeVagas"
            render={({ field: { onChange, value } }) => (
              <Input
                type="number"
                required
                variant={"edit"}
                value={value}
                label="Quantidade de Vagas Domicílio"
                placeholder="00"
                onChange={(e) => onChange(+e.target.value)}
              />
            )}
          />
        </div>

        <div>
          <Controller
            control={control}
            name="quantidadeVagasConcessionaria"
            render={({ field: { onChange, value } }) => (
              <Input
                type="number"
                required
                variant={"edit"}
                value={value}
                label="Quantidade de Vagas Concessionária"
                placeholder="00"
                onChange={(e) => onChange(+e.target.value)}
              />
            )}
          />
        </div>

        <div>
          <h4>Horário de Atendimento Semanal</h4>
        </div>

        <div>
          <Input
            {...register("horarioInicial")}
            required
            label="Horário Inicial"
            placeholder="hh:mm"
            variant={"edit"}
          />
        </div>

        <div>
          <Input
            {...register("horarioFinal")}
            required
            label="Horário Final"
            placeholder="hh:mm"
            variant={"edit"}
          />
        </div>

        <div>
          <h4>Intervalo de Almoço</h4>
        </div>

        <div>
          <Input
            {...register("horarioInicialAlmoco")}
            label="Horário Inicial"
            placeholder="hh:mm"
            variant={"edit"}
          />
        </div>

        <div>
          <Input
            {...register("horarioFinalAlmoco")}
            label="Horário Final"
            placeholder="hh:mm"
            variant={"edit"}
          />
        </div>

        <div>
          <h4>Horário de Atendimento - Sábado</h4>
        </div>

        <div>
          <Input
            {...register("horarioInicialFds")}
            label="Horário Inicial"
            placeholder="hh:mm"
            variant={"edit"}
          />
        </div>

        <div>
          <Input
            {...register("horarioFinalFds")}
            label="Horário Final"
            placeholder="hh:mm"
            variant={"edit"}
          />
        </div>

        <div>
          <Button>Salvar</Button>
        </div>
      </S.Form>
    </S.Container>
  );
};
